import { useEffect, useRef, useState } from 'react'
import Icon from '../../components/icons.jsx'
import { updateDeal } from '../../db/api.js'

export default function DealOwners({ deal, members, Avatar, onSaved, onOpenDetails }) {
  const [open, setOpen] = useState(false)
  const [draft, setDraft] = useState('')
  const [query, setQuery] = useState('')
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)
  const root = useRef(null)
  const trigger = useRef(null)
  // O backend guarda um único responsável por negócio (deals.owner_id).
  const ownerId = deal.owner_id || null
  const selected = ownerId ? [members.find((member) => member.id === ownerId) || { id: ownerId, nome: 'Usuário indisponível' }] : []
  useEffect(() => {
    if (!open) return
    const outside = (event) => { if (!saving && !root.current?.contains(event.target)) setOpen(false) }
    document.addEventListener('pointerdown', outside)
    return () => document.removeEventListener('pointerdown', outside)
  }, [open, saving])
  const save = async () => {
    if (saving) return
    if (draft === (ownerId || '')) { setOpen(false); trigger.current?.focus(); return }
    setSaving(true); setError('')
    try {
      let changes
      if (import.meta.env.DEV && import.meta.env.MODE === 'demo') {
        const { saveDemoDealOwners } = await import('../../demo/data.js')
        changes = saveDemoDealOwners(deal.id, draft ? [draft] : [])
      } else {
        await updateDeal(deal.id, { owner_id: draft || null })
        changes = { owner_id: draft || null }
      }
      onSaved(changes)
      setOpen(false); trigger.current?.focus()
    } catch (err) { setError(err.message) }
    finally { setSaving(false) }
  }
  return <div className="dp-owners" ref={root} onKeyDown={(event) => { if (event.key === 'Escape' && open) { event.stopPropagation(); if (!saving) { setOpen(false); trigger.current?.focus() } } }}>
    <div className="dp-identity-row"><div className="dp-owner-stack">{selected.length ? selected.slice(0, 3).map((member) => <button type="button" className="dp-avatar-link" key={member.id} aria-label={`Ver detalhes de ${member.nome}`} onClick={() => { setOpen(false); onOpenDetails?.(member) }}><Avatar src={member.avatar_url} /></button>) : <button type="button" className="dp-avatar-link" aria-label="Ver detalhes do responsável" onClick={() => onOpenDetails?.()}><Avatar /></button>}</div><button type="button" className="dp-owners-trigger" ref={trigger} aria-expanded={open} aria-label="Escolher responsável" onClick={() => { if (saving) return; setDraft(ownerId || ''); setQuery(''); setError(''); setOpen(!open) }}>

      <span><span className="cv-row-label">Responsável</span><span className="cv-row-value">{selected.map((member) => member.nome).join(', ') || 'Selecionar responsável'}</span></span>
      <span aria-hidden="true" className="dp-owners-chevron"><Icon n="chevron_d" s={14} /></span>
    </button></div>
    {open && <div className="dp-owners-menu">
      <input autoFocus aria-label="Buscar responsável" placeholder="Buscar usuário…" value={query} onChange={(event) => setQuery(event.target.value)} />
      <div className="dp-owners-options" role="group" aria-label="Usuários disponíveis">
        {!query.trim() && <label>
          <input type="radio" name={`deal-owner-${deal.id}`} checked={draft === ''} disabled={saving} onChange={() => setDraft('')} />
          <span>Sem responsável</span>
        </label>}
        {members.filter((member) => (member.nome || '').toLocaleLowerCase().includes(query.toLocaleLowerCase())).map((member) => <label key={member.id}>
          <input type="radio" name={`deal-owner-${deal.id}`} checked={draft === member.id} disabled={saving} onChange={() => setDraft(member.id)} />
          <Avatar src={member.avatar_url} /><span>{member.nome || 'Sem nome'}</span>
        </label>)}
        {!members.some((member) => (member.nome || '').toLocaleLowerCase().includes(query.toLocaleLowerCase())) && <p>Nenhum usuário encontrado.</p>}
      </div>
      {error && <p role="alert">{error}</p>}
      <footer><small>{draft ? '1 selecionado' : 'Sem responsável'}</small><button type="button" disabled={saving} onClick={() => { setOpen(false); trigger.current?.focus() }}>Cancelar</button><button type="button" disabled={saving || draft === (ownerId || '')} onClick={save}>{saving ? 'Salvando…' : 'Salvar'}</button></footer>
    </div>}
  </div>
}
